import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'containers/misc'
import { Form, Title } from 'components/layout'
import { form } from 'helpers/decorators'
import { Button, FormButton } from 'components/misc'
import { LABEL_CATEGORY_TYPES, LEADERS_BULK, ORGANIZATIONS_BULK, PARTICIPANTS_BULK } from '../../../constants/enums'
import { mapLabels } from '../../../helpers/mapForSelect'
import { Select } from '../../fields'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import assignLabelBulkValidate from '../../../models/labels/assignLabelBulkValidate'

@form({
  form: 'bulk-action-assign-label-modal',
  disableHook: true,
  validate: assignLabelBulkValidate
})
class BulkActionAssignLabelModal extends Component {
  static propTypes = {
    modalId: PropTypes.string,
    modal: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
    searchLabels: PropTypes.func.isRequired,
    bulkSetResult: PropTypes.func.isRequired,
    assignLabelBulk: PropTypes.func,
    unassignLabelBulk: PropTypes.func,
    assignAwardLabelBulk: PropTypes.func,
    unassignAwardLabelBulk: PropTypes.func,
    handleError: PropTypes.func.isRequired,
    itemCount: PropTypes.number.isRequired,
    selectedIds: PropTypes.array,
    values: PropTypes.object.isRequired,
    regAssignment: PropTypes.bool,
    labelType: PropTypes.string.isRequired
  }

  handleCloseModal = () => {
    this.props.reset()
    this.props.modal(null)
  }

  searchLabels = search => {
    const params = { limit: 50 }

    if (search && search.name) {
      params.filter = `or(name ic ${search.name})`
    }
    const orgId = get(this.props.activeOrganization, 'id')
    return this.props.searchLabels(this.props.labelType, params, orgId)
        .then(obj => obj.body)
        .then(obj => mapLabels(obj))
  }

  handleBulkAssignLabels = values => {
    const labels = get(values, 'labels')

    const labelsIds = labels && labels.map(l => l.value) || []

    const ids = this.props.selectedIds || []

    const type = get(this.props, 'type')

    switch(type){
      case PARTICIPANTS_BULK.assignLabels.id:
        this.props.assignLabelBulk(ids, labelsIds)
            .then(data => {
              this.props.bulkSetResult(data.body)
              this.handleCloseModal()

              if (!this.props.regAssignment) {
                this.props.modal('bulk-change-participants-results-modal')
              } else {
                this.props.modal('bulk-change-award-registrations-results-modal')
              }
            })
            .catch(this.props.handleError)
      break

      case PARTICIPANTS_BULK.unassignLabels.id:
        this.props.unassignLabelBulk(ids, labelsIds)
            .then(data => {
              this.props.bulkSetResult(data.body)
              this.handleCloseModal()

              if (!this.props.regAssignment) {
                this.props.modal('bulk-change-participants-results-modal')
              } else {
                this.props.modal('bulk-change-award-registrations-results-modal')
              }
            })
            .catch(this.props.handleError)
            break

      case PARTICIPANTS_BULK.assignAwardLabels.id:
        this.props.assignLabelBulk(ids, labelsIds)
          .then(data => {
            this.props.bulkSetResult(data.body)
            this.handleCloseModal()

            if (!this.props.regAssignment) {
              this.props.modal('bulk-change-participants-results-modal')
            } else {
              this.props.modal('bulk-change-award-registrations-results-modal')
            }
          })
          .catch(this.props.handleError)
        break

      case PARTICIPANTS_BULK.unassignAwardLabels.id:
        this.props.unassignAwardLabelBulk(ids, labelsIds)
          .then(data => {
            this.props.bulkSetResult(data.body)
            this.handleCloseModal()

            if (!this.props.regAssignment) {
              this.props.modal('bulk-change-participants-results-modal')
            } else {
              this.props.modal('bulk-change-award-registrations-results-modal')
            }
          })
          .catch(this.props.handleError)
        break

      case LEADERS_BULK.assignLabels.id:
        this.props.assignLabelBulk(ids, labelsIds)
            .then(data => {
              this.props.bulkSetResult(data.body)
              this.handleCloseModal()
                this.props.modal('bulk-change-leaders-results-modal')
            })
            .catch(this.props.handleError)
        break

      case LEADERS_BULK.unassignLabels.id:
        this.props.unassignLabelBulk(ids, labelsIds)
            .then(data => {
              this.props.bulkSetResult(data.body)
              this.handleCloseModal()
              this.props.modal('bulk-change-leaders-results-modal')
            })
            .catch(this.props.handleError)
        break

        case ORGANIZATIONS_BULK.assignLabels.id:
            this.props.assignLabelBulk(ids, labelsIds)
                .then(data => {
                    this.props.bulkSetResult(data.body)
                    this.handleCloseModal()
                    this.props.modal('bulk-change-organizations-results-modal')
                })
                .catch(this.props.handleError)
            break

        case ORGANIZATIONS_BULK.unassignLabels.id:
            this.props.unassignLabelBulk(ids, labelsIds)
                .then(data => {
                    this.props.bulkSetResult(data.body)
                    this.handleCloseModal()
                    this.props.modal('bulk-change-organizations-results-modal')
                })
                .catch(this.props.handleError)
            break

        default: break
    }
  }

    getLabelId = (labelType, assign) => {
        switch(labelType) {
            case LABEL_CATEGORY_TYPES.PERSON.id:

                if(assign){
                    return 'moduleTitle.assign_labels_bulk'
                } else {
                    return 'moduleTitle.unassign_labels_bulk'
                }

            case LABEL_CATEGORY_TYPES.ORGANIZATION.id:

                if(assign){
                    return 'moduleTitle.assign_organization_labels_bulk'
                } else {
                    return 'moduleTitle.unassign_organization_labels_bulk'
                }

            case LABEL_CATEGORY_TYPES.CONTACT.id:

                if(assign){
                    return 'moduleTitle.assign_contact_labels_bulk'
                } else {
                    return 'moduleTitle.unassign_contact_labels_bulk'
                }

            default:
                return 'moduleTitle.assign_labels_bulk'
        }
    }

    getDefaultMessage = (labelType, itemCount, assign) => {
        switch(labelType) {
            case LABEL_CATEGORY_TYPES.PERSON.id:
                if(assign){
                    return `Assign selected labels to ${itemCount} participants.`
                } else {
                    return `Unassign selected labels to ${itemCount} participants.`
                }
            case LABEL_CATEGORY_TYPES.ORGANIZATION.id:
                if(assign){
                    return `Assign selected labels to ${itemCount} organizations.`
                } else {
                    return `Unassign selected labels to ${itemCount} organizations.`
                }
            case LABEL_CATEGORY_TYPES.CONTACT.id:
                if(assign){
                    return `Assign selected labels to ${itemCount} award leaders.`
                } else {
                    return `Unassign selected labels to ${itemCount} award leaders.`
                }
            default:
                return 'moduleTitle.assign_labels_bulk'
        }
    }

  render() {
    const {
      modalId,
      handleSubmit,
      itemCount,
      values
    } = this.props

    const type = get(this.props, 'type')

    const assign = type === PARTICIPANTS_BULK.assignLabels.id || type === LEADERS_BULK.assignLabels.id || type === ORGANIZATIONS_BULK.assignLabels.id

    const labels = get(values, 'labels')

    const labelId = this.getLabelId(get(this.props, 'labelType'), assign)

    const defaultMsg = this.getDefaultMessage(get(this.props, 'labelType'), itemCount, assign)

    return (
    <Modal id={modalId} customActions>
      <Title h2>
        <FormattedMessage
            id={labelId}
            defaultMessage={defaultMsg}
            values={{
              itemCount: itemCount
            }}
        />
      </Title>
      <Form
          className="form"
          onSubmit={handleSubmit(this.handleBulkAssignLabels)}
      >
        <div className="row">
          <div className="col-xs-12">
          <Select
              label="Label"
              intlKey="label.label"
              name="labels"
              multi
              autocomplete
              promise={this.searchLabels}
              placeholder="Start typing ..."
              intlKeyPlaceholder="placeholder.start_typing"
              backspaceToRemoveMessage={''}
          />
          </div>
        </div>

        <div style={{ marginTop: '40px' }}>
        <div className="row">
          <div className="col-xs-6">
            <Button
                intlKey="button.cancel"
                onClick={() => this.handleCloseModal()}
                secondary
                type="button"
                style={{ marginRight: 10 }}
            >
              Cancel
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <FormButton
                {...this.props}
                intlKey={assign ? 'button.assign' : 'button.remove'}
                disabled={!labels || labels.length === 0}
            >
              {assign ? 'Assign' : 'Remove'}
            </FormButton>
          </div>
        </div>
        </div>
      </Form>
    </Modal>
    )
  }
}

export default BulkActionAssignLabelModal
